import React, { createContext, useContext } from 'react';

const ArtistThemeContext = createContext();

export const useArtistTheme = () => {
  const context = useContext(ArtistThemeContext);
  if (!context) {
    throw new Error('useArtistTheme must be used within an ArtistThemeProvider');
  }
  return context;
};

export const ArtistThemeProvider = ({ children }) => {
  const theme = {
    getColor: (path) => {
      const colorMap = {
        'artist.primary': '#1e40af', // Blue
        'artist.secondary': '#7c3aed', // Purple
        'artist.accent': '#f59e0b', // Amber
        'artist.success': '#059669', // Green
        'artist.warning': '#d97706', // Orange
        'artist.destructive': '#dc2626', // Red
        'artist.muted': '#6b7280', // Gray
        'artist.background': '#ffffff', // White
        'artist.foreground': '#111827', // Dark gray
      };
      return colorMap[path] || '#1e40af';
    },
    
    getSpacing: (size) => {
      const spacingMap = {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        '2xl': '3rem',
      };
      return spacingMap[size] || '1rem';
    },
    
    getBorderRadius: (size) => {
      const radiusMap = {
        sm: '0.25rem',
        md: '0.5rem',
        lg: '0.75rem',
        xl: '1rem',
        full: '9999px',
      };
      return radiusMap[size] || '0.5rem';
    },
    
    getShadow: (size) => {
      const shadowMap = {
        sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
        md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
        lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
        xl: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
      };
      return shadowMap[size] || 'none';
    },
  };

  return (
    <ArtistThemeContext.Provider value={theme}>
      {children}
    </ArtistThemeContext.Provider>
  );
};
